import '../bc-segments/bc-segments.js';
import Vue from 'vue';
import rootSettings from './root';
import plugin from './plugin';



// Vue.config.productionTip = false;
Vue.use(plugin);



window.bcBanner = new Vue(rootSettings);



// WEBPACK FOOTER //
// ./src/shared/bc-banner/bootstrap.js